var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('p',[_vm._v(_vm._s(_vm.error))]),_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":_vm.clearError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }